import axios from "axios";

const basicAxios = axios.create({
  timeout: 20000,
  headers: {
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
  },
});

export const makePostTarballDownload = (fileName, fileData) =>
  basicAxios.post(
    "/api/tarball",
    {
      fileName,
      fileData,
    },
    { responseType: "blob" }
  );
